import { CheckIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

export const StepShowBenefits = () => {
  // Translation
  const { t } = useTranslation('common');

  const benefits = [
    t('premium.talent.hero.benefits.1.heading'),
    t('premium.talent.hero.benefits.2.heading'),
    t('premium.talent.hero.benefits.3.heading'),
    t('premium.talent.hero.benefits.4.heading'),
  ];

  // Render component
  // *****************************************
  return (
    <div>
      <div className="flex items-center self-stretch">
        <div className="flex-basis-0 grow text-xl font-bold leading-[30px] text-ink-medium">
          {t('premium.talent.closeRequest.benefits.heading')}
        </div>
        <div className="flex justify-end">
          <span className="px-1 text-secondary">1</span>
          <span className="px-1 text-base">/</span>
          <span className="px-1 text-base">2</span>
        </div>
      </div>

      <hr className="my-6 border-gray-400" />

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-400">
          <thead>
            <tr>
              <th scope="col" className="w-2/3 px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-ink-medium">
                {t('premium.talent.closeRequest.advantages')}
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-ink-medium">
                {t('premium.talent.closeRequest.nonPremium')}
              </th>
              <th scope="col" className="px-6 py-3 text-right text-xs font-bold uppercase tracking-wider text-ink-medium">
                {t('premium.talent.closeRequest.premium')}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-400">
            {benefits.map((benefit, index) => {
              // Generate a unique key by concatenating the benefit with its index
              const key = `benefits-modal-${index}`;

              return (
                <tr key={key}>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-ink">
                    {benefit}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-ink">
                    <div className="flex items-center gap-2">
                      <XMarkIcon className="size-6 text-red-500" />
                      {t('premium.talent.closeRequest.notIncluded')}
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-ink">
                    <div className="flex items-center justify-end gap-2">
                      <CheckIcon className="size-6 text-green-500" />
                      {t('premium.talent.closeRequest.included')}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

